import VueCookies from 'vue-cookies'
import {
    getUserInfoApi
} from "@/api/commonApi";
const userType = {
    free: 100, // 免费用户
    pay: 101, //  付费用户
    experience: 102 //体验用户
};
export default {
    state: {
        electronAccountInfo: {
            enable_end_time: null,
            expired_type: null,
            type_id: null,
            user_id: null,
            user_type_id: null,
        },
        paidModalVisible: false
    },
    getters: {
        getElectronAccountInfo: state => {
            return state.electronAccountInfo;
        },
        getElectronPaidModalVisible: state => {
            return state.paidModalVisible;
        },
    },
    mutations: {
        SET_ELECTRON_ACCOUNT_INFO: (state, data) => {
            state.electronAccountInfo = data;
        },
        SET_PAID_MODAL_VISIBLE: (state, data) => {
            state.paidModalVisible = data;
        },
    },
    actions: {
        ELECTRON_ACCOUNT_INFO({
            commit
        }, data) {
            getUserInfoApi({})
                .then((res) => {
                    if (res.errCode == 0) {
                        commit('SET_ELECTRON_ACCOUNT_INFO', res.data);
                        if (
                            res.data.type_id != userType.free &&
                            res.data.type_id != userType.pay &&
                            res.data.type_id != userType.experience
                        ) {
                            return;
                        }
                        // 体验用户快过期&已过期弹续费
                        if (res.data.expired_type == 1 || res.data.expired_type == 2) {
                            if (VueCookies.get("paid_modal_visible") == "false") {
                                return;
                            }
                            //commit('SET_PAID_MODAL_VISIBLE', true);
                        }
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        PAID_MODAL_VISIBLE({
            commit
        }, data) {
            commit('SET_PAID_MODAL_VISIBLE', data);
        },

    }
}